// PRD.275 — Elia AI Assistant Drawer (Phase 1, UI only).
//
// Approved Elia mascot avatar: a flat four-colour rounded-square face with pink
// round glasses. Centralized here and reused by the trigger, header, and
// assistant-message identity. Decorative (empty alt) — nearby text says
// "Elia AI". Always signals "AI", never a human clinician.

import eliaAvatarUrl from './assets/elia-ai-avatar.svg';

export function EliaAvatar({ size = 32 }: { size?: number }) {
  return (
    <img
      src={eliaAvatarUrl}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      draggable={false}
      style={{
        width: size,
        height: size,
        display: 'block',
        flexShrink: 0,
        objectFit: 'contain',
      }}
    />
  );
}
